import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { NovoCampanhaMultiselectComponent } from './novo-campanha-multiselect.component';

@NgModule({
  imports: [SharedModule],
  declarations: [NovoCampanhaMultiselectComponent],
  exports: [NovoCampanhaMultiselectComponent]
})
export class NovoCampanhaMultiselectModule {}
